import AuthorizePage from "pages/login/Authorize";
import LoginPage from "pages/login/Login";
import { Navigate, Route } from "react-router-dom";

const routes = {
  key: "LOGIN",
  routes: () => [
    <Route key={"login"} path="login" element={<LoginPage />} />,
    <Route key={"authorize"} path="authorize" element={<AuthorizePage />} />,
    <Route
      key={"redirection"}
      path="/"
      element={<Navigate to="perso/dashboard/shared/ic" />}
    />,
  ],
};
export default routes;
